import { TextInput as MantineTextInput } from '@mantine/core';

export const TextInput = MantineTextInput.extend({
	defaultProps: {
		variant: 'primary',
	},
});
